import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { PERSON_ROUNDED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const PersonRoundedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={PERSON_ROUNDED_GLYPH} />;
